// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.setting-panel-title {
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(100% - 44px);
  height: 38px;
  font-weight: 500;
  margin: 4px 22px;
}
.setting-panel-parent {
  position: absolute;
  right: 0px;
  top: 0px;
  width: 299px;
  height: 100%;
  overflow: hidden;
  animation: fade-right 0.2s ease-in-out 0s 1;
  z-index: 10;
  opacity: 1;
}

.setting-panel {
  opacity: 1;
  width: 100%;
  height: calc(100% - 55px);
  overflow-y: scroll;
  box-sizing: border-box;

  /* display: none; */
}
.single-control-switch-container {
  margin: 15px 20px 10px;
  /* height: 20px; */
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}
.single-control-switch-title {
  font-size: 15px;
  line-height: 16px;
  font-weight: 500;
  max-width: calc(100% - 40px);
}
.single-control-switch {
  display: inline-block;
  width: 40px;
  height: 20px;
  opacity: 1;
  border-radius: 10px;
  position: relative;
  top: 3px;
  left: 2px;
  cursor: pointer;
}
.single-control-button {
  display: inline-block;
  height: 16px;
  width: 16px;
  border-radius: 50%;
  margin: 2px;
}
.lock-icon {
  position: absolute;
  top: 0px;
  left: 0px;
  font-size: 20px;
  opacity: 0.3;
  margin: 10px;
  cursor: pointer;
  font-size: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/containers/panels/settingPanel/settingPanel.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;EACxB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,2CAA2C;EAC3C,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;;EAEtB,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;AAC9B;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;AACjB","sourcesContent":[".setting-panel-title {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: calc(100% - 44px);\n  height: 38px;\n  font-weight: 500;\n  margin: 4px 22px;\n}\n.setting-panel-parent {\n  position: absolute;\n  right: 0px;\n  top: 0px;\n  width: 299px;\n  height: 100%;\n  overflow: hidden;\n  animation: fade-right 0.2s ease-in-out 0s 1;\n  z-index: 10;\n  opacity: 1;\n}\n\n.setting-panel {\n  opacity: 1;\n  width: 100%;\n  height: calc(100% - 55px);\n  overflow-y: scroll;\n  box-sizing: border-box;\n\n  /* display: none; */\n}\n.single-control-switch-container {\n  margin: 15px 20px 10px;\n  /* height: 20px; */\n  display: flex;\n  justify-content: space-between;\n  cursor: pointer;\n}\n.single-control-switch-title {\n  font-size: 15px;\n  line-height: 16px;\n  font-weight: 500;\n  max-width: calc(100% - 40px);\n}\n.single-control-switch {\n  display: inline-block;\n  width: 40px;\n  height: 20px;\n  opacity: 1;\n  border-radius: 10px;\n  position: relative;\n  top: 3px;\n  left: 2px;\n  cursor: pointer;\n}\n.single-control-button {\n  display: inline-block;\n  height: 16px;\n  width: 16px;\n  border-radius: 50%;\n  margin: 2px;\n}\n.lock-icon {\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  font-size: 20px;\n  opacity: 0.3;\n  margin: 10px;\n  cursor: pointer;\n  font-size: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
